export class Button extends HTMLElement {
  constructor() {
    super();
  }
}

export const buttonTag = 'lib-button';

export const buttonStyle = `
  color: green;
  font-weight: bold;
`;
